import React, { useState } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteEntrevista } from "../api/entrevistaApi";
import { usePermissions } from "../../../shared/auth/PermissionsContext";

const ExcludeEntrevistaButton = ({ entrevistaId, onDeleted }) => {
  const { hasPermission } = usePermissions();
  const [openDialog, setOpenDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [error, setError] = useState("");

  const handleOpen = (event) => {
    event.stopPropagation();
    setError("");
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteEntrevista(entrevistaId);
      setOpenDialog(false);
      setOpenSnackbar(true);
      if (onDeleted) {
        onDeleted();
      }
    } catch (err) {
      console.error("Error al excluir la entrevista:", err);
      setError("No se pudo excluir la entrevista. Inténtalo nuevamente.");
    } finally {
      setIsDeleting(false);
    }
  };

  if (!hasPermission("pruebas:delete")) {
    return null;
  }

  return (
    <>
      <IconButton color="error" size="small" onClick={handleOpen}>
        <DeleteIcon fontSize="small" />
      </IconButton>

      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle>Confirmar exclusión</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            ¿Deseas excluir la entrevista {entrevistaId}? Esta acción no se puede deshacer.
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={isDeleting}>
            Cancelar
          </Button>
          <Button
            onClick={handleDelete}
            color="error"
            disabled={isDeleting}
          >
            {isDeleting ? "Excluyendo..." : "Excluir"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert severity="success" onClose={handleSnackbarClose}>
          Entrevista excluida correctamente.
        </Alert>
      </Snackbar>
    </>
  );
};

export default ExcludeEntrevistaButton;

